import {
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
} from '@mui/material';

export interface Props {
	value?: any;
	list?: { id: any; name: string }[];
}

export default function AppRadioView({ value, list }: Props) {
	return (
		<>
			<FormControl>
				<RadioGroup row name='mediaType' value={value}>
					{(list || []).map((item) => (
						<FormControlLabel
							key={item.id}
							disabled
							value={item.id}
							control={<Radio />}
							label={item.name}
						/>
					))}
				</RadioGroup>
			</FormControl>
		</>
	);
}
